/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import * as styled from 'styled-components';
import { normalize } from 'styled-normalize';

export default styled.createGlobalStyle`
  ${normalize}

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .mapboxgl-ctrl-attrib {
    font-size: 11px;
  }

  img {
    width: 100%;
    height: auto;
  }

  /* Reduce motion flag */
  @media (prefers-reduced-motion: reduce) {
    button {
      animation: none;
    }
  }
`;
